// libs
import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Close } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { LinkButton, Stack, Tooltip } from '@lyearn/ui';
// types
import CollectionItem from '@/modules/corporate/modules/group/views/GroupManager/components/CollectionsDialog/CollectionItem';
import { ContentCollectionFragment } from '@/modules/corporate/modules/group/views/GroupManager/graphql/fragments/generated/ContentCollection';

import { contentStyles } from './style';

function CollectionItemViewer({
  collection,
  onDelete,
  disabled,
  Actions,
}: {
  collection: ContentCollectionFragment;
  onDelete?: (collectionId: string) => void;
  disabled?: boolean;
  Actions?: JSX.Element;
}) {
  const { t } = useTranslation('Group');
  const _onDelete = useCallback(() => onDelete?.(collection.id), [onDelete, collection.id]);

  return (
    <Stack
      className={cn(contentStyles, 'rounded-8 px-4', {
        'group hover:bg-s-info-light': !disabled,
      })}>
      <Stack
        alignItems="center"
        className="content w-full border-b border-solid border-interactive-border py-16 px-12"
        justifyContent="between">
        <CollectionItem group={collection} />
        {Actions || (
          <Tooltip placement="right" title={`${t('Group:RemoveCollection')}`}>
            <LinkButton
              className="flex-shrink-0 py-2 px-4 opacity-0 transition duration-150 ease-linear group-hover:opacity-100"
              color={'internal'}
              disabled={disabled}
              onClick={_onDelete}>
              <Close />
            </LinkButton>
          </Tooltip>
        )}
      </Stack>
    </Stack>
  );
}

export default CollectionItemViewer;
